import React from "react";
import Introduction from "./utils/Introduction";
import Mission3 from "./utils/Mission3";
import Mission2 from "./utils/Mission2";
import End from "./utils/End";

export function Vertex(props) {
  return (
    <div className="challenge-details container">
      <div>
        <Introduction
          logo={props.logo}
          track="Artificial Intelligence Engineer"
        />
        <h2 className="mission-1">
          Mission 1: Build and deploy a model with <strong>Vertex AI</strong>
        </h2>
        <h3>Description</h3>
        <p>
          In this challenge, you use Google’s managed ML platform Vertex AI to
          build an end-to-end machine learning workflow.
          <br />
          <br /> For the basic requirement of this challenge, follow the steps
          explained
          <a
            href="https://codelabs.developers.google.com/codelabs/vertex-ai-custom-models#0"
            target="_blank"
          >
            {" "}
            in this tutorial.{" "}
          </a>
          You can use your free trial credits to run it. You use the{" "}
          <a
            href="https://www.kaggle.com/uciml/autompg-dataset"
            target="_blank"
          >
            Auto MPG dataset from Kaggle{" "}
          </a>{" "}
          to predict the fuel efficiency of a vehicle using a basic regression
          with TensorFlow. Generate the model prediction results for the
          following input array: test_mpg = [1, 2, 3, 2, -2, -1, -2, -1, 0].{" "}
          <br />
          <br />
          If you are interested and as a <i>bonus point</i>, you can replace the
          dataset and the custom model with any other application of machine
          learning.
        </p>
        <h2 className="mission-2">Mission 2: Publish your source code</h2>
        <h3 id="description-1">Description</h3>
        <p>
          Publish your commands or source code in a
          <strong>github repository</strong>. It should both contain the
          commands/code of every step and some of the key outputs (as an image).
          If you are not familiar with github, follow the instructions{" "}
          <a href="https://docs.github.com/en/github/getting-started-with-github/create-a-repo">
            here
          </a>
          .
        </p>
        <Mission3 notes="you must write your prediction results for the input array: test_mpg = [1, 2, 3, 2, -2, -1, -2, -1, 0]. Optionally, you may also add anything else that you would like us to know." />
        <h2 className="thank-you">Bonus Points!</h2>
        <p>
          {" "}
          A bonus will be given if you record a 2-min video and explain your
          end-to-end ML system. You can upload the video to your GitHub
          repository or send it by email to ({" "}
          <a href="mailto:asaei@unternehmertum.de">
            asaei@unternehmertum.de
          </a>{" "}
          ).
          <br />
          Another bonus will be given if you use a custom model different from
          the tutorial.
        </p>
        <End />
      </div>
    </div>
  );
}
